/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import PropTypes from 'prop-types'

export const TransformPropType = PropTypes.shape({
  x: PropTypes.number,
  y: PropTypes.number,
  r: PropTypes.number,
  s: PropTypes.number
})

export const AnimPropType = PropTypes.shape({
  keyframes: PropTypes.arrayOf(Object),
  timing: PropTypes.shape({
    delay: PropTypes.number,
    endDelay: PropTypes.number,
    fill: PropTypes.oneOf(['none', 'forwards', 'backwards', 'both', 'auto']),
    iterationStart: PropTypes.number,
    iterations: PropTypes.number,
    duration: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    direction: PropTypes.oneOf(['normal', 'reverse', 'alternate', 'alternate-reverse']),
    easing: PropTypes.string
  }),
  onFinish: PropTypes.func
})
